import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import {detectIconById, getCookie} from '../common/enum';
// import { team1 } from './data';
import {numeralFormat} from '../common/numeralFormat';

const ACTIONS = {
    GET_INFO_TEAM_1_SUCCESS: 'GET_INFO_TEAM_1_SUCCESS',
    GET_INFO_TEAM_1_ERROR: 'GET_INFO_TEAM_1_ERROR'
};

const updateStatus = (type, data) => ({
    type,
    data,
});


const getTeam1 = (team_id) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    // team_id (number)
    let url = `${host.serverTest}api/teams/${team_id}/analytic/basic`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_INFO_TEAM_1_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_INFO_TEAM_1_ERROR, err));
            });
    };
};


const convertBatterPitcherUse = (list, teamId, title) => {
    if (list) {
        const arr = list.map((value) => {
            let number;
            if (title === '打率') {
                number = numeralFormat(value.value, 3)
            } else {
                number = value.value;
            }
            const img = detectIconById(teamId);
            return {
                id: value.player_id,
                item: [
                    { text: value.rank },
                    {
                        text: value.player_name,
                        img: img
                    },
                    { text: number }
                ]
            }
        });
        return arr;
    }
}

const convertListBatter = (list, teamId) => {
    if (list) {
        const arr = list.map((value) => {
            return {
                id: value.player_id,
                title: {
                    dot: false,
                    text: value.title
                 },
                headerTable: ['順位', '選手名', value.value_label],
                items: convertBatterPitcherUse(value.players, teamId, value.title)
            }
        });
        return arr;
    }
}

export {
    ACTIONS, getTeam1, convertBatterPitcherUse, convertListBatter
};